import React from "react";
//import "@stripe/stripe-js"
//import { StripeClient } from "../../generated";
import { CompanyDataDto, UserDataDto } from "../../generated";
import { RouteComponentProps } from "react-router-dom";
import CompanyForm, { NewEsercente } from "./newCompanyForm";
import { links } from "../../routes";
import esercentiActions from "../esercentiActions";
import { messageAlert } from "../../common/components/confirm";

interface Props extends RouteComponentProps {
}

export default ({ history }: Props) => {

    const onConfirmCompanyData = async (company: NewEsercente) => {
        if (await esercentiActions.esercenteExist(company.partitaIvaEsercente!)) {
            await messageAlert("La partita IVA esiste già nel sistema! Se hai dimenticato la password utilizza la funzionalità per recuperare la password oppure contatta un amminsitratore di CaldaieManager");
            return;
        }
        let result = await esercentiActions.add(
            new CompanyDataDto(company),
            [new UserDataDto({
                amministratore: true,
                disabilitato: false,
                nomeOperatore: company.nomeTitolare,
                password: company.password,
                username: company.emailEsercente,
            })]
        );
        if (result) {
            await messageAlert(<div className="alert alert-success text-center" role="alert" style={{ fontSize: "1.2em" }}>
                <div className="mb-2"><i className="far fa-thumbs-up fa-5x" /></div>
                <div>Benvenuto in Caldaie Manager. Puoi ora effetturare la login utilizzando le credenziali da te scelte.</div>
            </div>, "Registrazione completata!")
            history.push(links.login);
        }
        else
            await messageAlert("Attenzione si sono verificati dei problemi in fase di registrazione dell'azienda. Contatta l'assistenza.");
    }

    return (
        <div className="container card card-outline-info">
            <div className="card-body">
                <h2 className="mb-3">Registra la tua azienda</h2>
                <CompanyForm
                    onSubmit={onConfirmCompanyData}
                    onCancel={() => history.push(links.login)}
                />
            </div>
        </div>
    );
}
